import { useState, useRef, useEffect } from 'react'


export const useContentTransition = (currentIndex: number) => {
    const [isTransitioning, setIsTransitioning] = useState(false)
    const [transitionDirection, setTransitionDirection] = useState< 'left' | 'right' | null>(null)
    const previousCompetencyIndexRef = useRef(currentIndex)
  
    useEffect(() => {
      const previousIndex = previousCompetencyIndexRef.current
      if (previousIndex === currentIndex) {
        return
      }
  
      const direction = currentIndex > previousIndex ? 'left' : 'right'
      setTransitionDirection(direction)
      setIsTransitioning(true)
      previousCompetencyIndexRef.current = currentIndex
  
      const timeout = setTimeout(() => {
        setIsTransitioning(false)
      }, 280)
  
      return () => clearTimeout(timeout)
    }, [currentIndex])

    return {
        isTransitioning,
        transitionDirection,
    }
}       